document.addEventListener("DOMContentLoaded", function () {
  if (!window.amount_discount_enabled) {
    console.log("[DYABOO NUEVO DESCUENTO] ⛔ Mensaje desactivado desde configuración");
    return;
  }

  console.log("[DYABOO NUEVO DESCUENTO] 🟢 Script de prueba ejecutado correctamente");

  const THRESHOLD_COLECCION = "productos-sin-descuento";
const THRESHOLD_MINIMO = parseInt(window.amount_discount_minimum || "150000", 10);
const THRESHOLD_PORCENTAJE = parseInt(window.amount_discount_percent || "10", 10);

  const MENSAJE_CUMPLE = `🎉 ¡Genial! Obtendrás un descuento del ${THRESHOLD_PORCENTAJE}% por comprar más de ${new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(THRESHOLD_MINIMO)} en esta colección.`;
  
  const MENSAJE_INCOMPLETO = (restante) =>
    `🧾 Te faltan ${new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(restante)} para activar un <strong>${THRESHOLD_PORCENTAJE}% de descuento</strong> en esta colección.`;


  function actualizarMensajeDescuento() {
    console.log("[DYABOO NUEVO DESCUENTO] 🔍 Ejecutando verificación de carrito...");

    const contenedorMensaje = document.querySelector(".pt-descuento-monto-msg");
    const productos = document.querySelectorAll(".pt-cart-list .pt-item");

    if (!contenedorMensaje) {
      console.warn("[DYABOO NUEVO DESCUENTO] ❌ No se encontró .pt-descuento-monto-msg");
      return;
    }

    let subtotal = 0;
    let todosValidos = true;

    productos.forEach((producto) => {
      const precioEl = producto.querySelector(".pt-price");
      const cantidadEl = producto.querySelector(".pt-quantity");

      if (!precioEl || !cantidadEl) return;

      const precio = parseInt(precioEl.textContent.replace(/\D/g, ""), 10);
      const cantidad = parseInt(cantidadEl.textContent.match(/\d+/)?.[0] || "1", 10);

      subtotal += precio * cantidad;

      const esValido = producto.getAttribute("data-coleccion") === THRESHOLD_COLECCION;
      if (!esValido) todosValidos = false;
    });

    console.log(`[DYABOO NUEVO DESCUENTO] 💰 Subtotal: ${subtotal}`);
    console.log(`[DYABOO NUEVO DESCUENTO] ✅ Todos válidos: ${todosValidos}`);

    if (!todosValidos || subtotal === 0) {
      contenedorMensaje.innerHTML = "";
      return;
    }

    if (subtotal >= THRESHOLD_MINIMO) {
      contenedorMensaje.innerHTML = `<div class="pt-descuento-monto-text">${MENSAJE_CUMPLE}</div>`;
    } else {
      const faltante = THRESHOLD_MINIMO - subtotal;
      contenedorMensaje.innerHTML = `<div class="pt-descuento-monto-text">${MENSAJE_INCOMPLETO(faltante)}</div>`;
    }
  }

  const carrito = document.querySelector(".pt-cart-list");
  if (carrito) {
    document.addEventListener("dyaboo:cart-updated", actualizarMensajeDescuento);
    setTimeout(() => actualizarMensajeDescuento(), 500);
  }
});
